"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCurrentGuildTopMembersResponseToJSON = exports.GetCurrentGuildTopMembersResponseFromJSONTyped = exports.GetCurrentGuildTopMembersResponseFromJSON = void 0;
var _1 = require("./");
function GetCurrentGuildTopMembersResponseFromJSON(json) {
    return GetCurrentGuildTopMembersResponseFromJSONTyped(json, false);
}
exports.GetCurrentGuildTopMembersResponseFromJSON = GetCurrentGuildTopMembersResponseFromJSON;
function GetCurrentGuildTopMembersResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'members': (json['members'].map(_1.TopGuildLeaderLeaderboardFromJSON)),
    };
}
exports.GetCurrentGuildTopMembersResponseFromJSONTyped = GetCurrentGuildTopMembersResponseFromJSONTyped;
function GetCurrentGuildTopMembersResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'members': (value.members.map(_1.TopGuildLeaderLeaderboardToJSON)),
    };
}
exports.GetCurrentGuildTopMembersResponseToJSON = GetCurrentGuildTopMembersResponseToJSON;
